package anjuros.development.pages

import androidx.compose.runtime.*
import anjuros.development.components.OverflowMenu
import anjuros.development.components.language.LanguageContext
import anjuros.development.components.language.LocalLanguage
import anjuros.development.components.language.detectLanguage
import anjuros.development.sections.FAQSection
import anjuros.development.sections.FacilitySection
import anjuros.development.sections.FooterSection
import anjuros.development.sections.MainSection
import anjuros.development.sections.NearbySection
import anjuros.development.sections.ReviewSection
import anjuros.development.sections.RoomsSection
import com.varabyte.kobweb.compose.css.Contain.Companion.Style
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun HomePage() {
    androidx.compose.runtime.LaunchedEffect(Unit) {
        val link = kotlinx.browser.document.createElement("link") as org.w3c.dom.HTMLLinkElement
        link.rel = "stylesheet"
        link.href = "/css/styles.css"
        kotlinx.browser.document.head?.appendChild(link)
    }
    var lang by remember { mutableStateOf(detectLanguage()) }
    val languageContext = LanguageContext(
        lang = lang,
        setLang = { lang = it }
    )
    var menuOpened by remember { mutableStateOf(false) }


    CompositionLocalProvider(LocalLanguage provides languageContext) {

        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                MainSection() {
                    menuOpened = true
                }
                RoomsSection()
                ReviewSection()
                NearbySection()
                FacilitySection()
                FAQSection()
                FooterSection()

            }
            if (menuOpened) {
                OverflowMenu { menuOpened = false }
            }
        }
    }
}
